import { render, staticRenderFns } from "./FolioConfig.vue?vue&type=template&id=10cbe723&scoped=true"
import script from "./FolioConfig.vue?vue&type=script&lang=js"
export * from "./FolioConfig.vue?vue&type=script&lang=js"
import style0 from "./FolioConfig.vue?vue&type=style&index=0&id=10cbe723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbe723",
  null
  
)

export default component.exports